import request from "@/util/request";

// 获取示范果园\种植大户 等数据
export function findOrgCompanyByType(data) {
  return request({
    url: "/api/restful/findOrgCompanyByType",
    method: "get",
    params: data
  });
}

// 获取企业类型 图例
export function findOrgCompanyCount(data) {
  return request({
    url: "/api/restful/findOrgCompanyCount",
    method: "get",
    params: data
  });
}
// 获取企业类型 筛选
export function findOrgCompanyByTypeGetOrgCompany(data) {
  return request({
    url: "/api/restful/findOrgCompanyByTypeGetOrgCompany",
    method: "get",
    params: data
  });
}
// 获取资金投入和建设进度 图例
export function findDataProjectTypes(data) {
  return request({
    url: "/api/restful/findDataProjectTypes",
    method: "get",
    params: data
  });
}

//智慧物联点列表
export function getMMLZDPZHWL(data) {
  return request({
    url: "/api/restful/getMMLZDPZHWL",
    method: "get",
    params: data
  });
}

// 农村--扶贫项目
export function getFpxmData(data) {
  return request({
    url: "/api/restful/gatAccordingToTheRegionClassification",
    method: "get",
    params: data
  });
}

// 示范村
export function getDemonstrationVillage(data) {
  return request({
    url: "/api/restful/getDemonstrationVillage",
    method: "get",
    params: { type: data }
  });
}

// 分镇情况
export function getInformationCard(data) {
  return request({
    url: "/api/restful/getPovertyAlleviationInformationCard",
    method: "get",
    params: data
  });
}

// 查询所有虫害预警
export function findPestWarningAll() {
  return request({
    url: "/api/restful/findPestWarningAll",
    method: "get"
  });
}
